export default __webpack_public_path__ + "images/Asset.v-3253b1042babbec0bf66ad71948db0cc.png";